import {Navigate} from 'react-router'
import {LoggedRoute} from './../logged-route'
import {
  DefaultCourseRedirectHandler,
  CourseRedirectHandler,
  MathAssignmentsCourseRedirectHandler,
} from './lazy'
import {WithRedirectLogging} from './redirect-logger'

export const routerV2Redirects = [
  {
    path: '/default-course/*',
    element: (
      <WithRedirectLogging routeName={'/default-course/*'}>
        <LoggedRoute component={DefaultCourseRedirectHandler} />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/courses/:courseId/assignments',
    element: (
      <WithRedirectLogging routeName={'/courses/:courseId/assignments'}>
        <LoggedRoute component={MathAssignmentsCourseRedirectHandler} />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/courses/:courseId/*',
    element: (
      <WithRedirectLogging routeName={'/courses/:courseId/*'}>
        <LoggedRoute component={CourseRedirectHandler} />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/rosters/courses/:courseId/edit',
    element: (
      <WithRedirectLogging routeName={'/rosters/courses/:courseId/edit'}>
        <LoggedRoute component={CourseRedirectHandler} />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/start',
    element: (
      <WithRedirectLogging routeName={'/start'}>
        <Navigate to="/dashboard" replace />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/school',
    element: (
      <WithRedirectLogging routeName={'/school'}>
        <Navigate to="/settings" replace />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/login-cards',
    element: (
      <WithRedirectLogging routeName={'/login-cards'}>
        <Navigate to="/rosters/login-cards" replace />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/math',
    element: (
      <WithRedirectLogging routeName={'/math'}>
        <Navigate to="/math/overview" replace />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/science',
    element: (
      <WithRedirectLogging routeName={'/science'}>
        <Navigate to="/science-units" replace />
      </WithRedirectLogging>
    ),
  },
  {
    path: '/social-studies',
    element: (
      <WithRedirectLogging routeName={'/social-studies'}>
        <Navigate to="/social-studies-units" replace />
      </WithRedirectLogging>
    ),
  },
]
